module.exports = {"620524100":"城关镇","620524101":"洛门镇","620524102":"鸳鸯镇","620524103":"滩歌镇","620524104":"四门镇","620524105":"马力镇","620524106":"山丹镇","620524107":"温泉镇","620524108":"桦林镇","620524109":"龙台镇","620524110":"榆盘镇","620524111":"高楼镇","620524112":"杨河镇","620524202":"咀头乡","620524206":"沿安乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620524.json
// module id = 2912
// module chunks = 0